import { render, staticRenderFns } from "./adminInfo.vue?vue&type=template&id=68f191ff&scoped=true"
import script from "./adminInfo.vue?vue&type=script&lang=js"
export * from "./adminInfo.vue?vue&type=script&lang=js"
import style0 from "./adminInfo.vue?vue&type=style&index=0&id=68f191ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f191ff",
  null
  
)

export default component.exports